import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

const VideoCarousel = ({ videos }) => {
  return (
    <div className="w-4/5 mx-auto">
      <Carousel
        showThumbs={false}
        showStatus={false}
        infiniteLoop
        useKeyboardArrows
        autoPlay
        interval={5000}
        stopOnHover
      >
        {videos.map((video, index) => (
          <div key={index}>
            <img 
              src={`${import.meta.env.VITE_FOTO || ''}/${video.thumbnail}`} 
              alt={video.title}
              className="w-[32rem] h-[18rem] object-cover rounded-lg"
            />
            <p className="bg-black/50 p-2.5 rounded-b-lg text-white">{video.title}</p>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default VideoCarousel;










